<mat-card class="coverage-over-vew-widget-container">
  <div #exportContent>
    <div class="header">
      <span class="title">Coverage Overview</span>
      <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <mat-card-content>
      <p>
        Analytics for counties with no data capture or <50% coverage in EAGLE-I™ should be carefully considered, as a
        lack
        of information may point to existing critical vulnerabilities and needed infrastructure investments to improve
        overall statewide resilience.
      </p>
    </mat-card-content>
  </div>
</mat-card>
